import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../abstraction/auth.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { USER_LABEL } from '../../models/User';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  isCompany = false;
  USER_LABEL = USER_LABEL;

  constructor(
    public auth: AuthService,
    public router: Router,
    public dialog: MatDialog,
    private titleService: Title,
  ) {
    this.titleService.setTitle('TiendaCrypto | Mi perfil');
  }

  ngOnInit() {
    this.auth.sendTikTokPageView(window.location.href).subscribe();
    if (!this.auth.checkOnboardingStatus()) {
      this.router.navigate(['core']);
    }
    this.isCompany = this.auth.isCompany();
  }
}
